import React, { useState, useRef, useEffect } from 'react';
import { Button } from 'ui';
import Excerpt from 'projects/components/Excerpt';

const Citation = ({ citationRef, onClick, citationNumber, excerptId, onTextClicked, selected }) => {
    const thisClick = (e) => {
        if ( e ) {
            e.preventDefault(); // Prevent the default link action
            e.stopPropagation(); // Prevent the event from bubbling up
        }

        onClick()
    }

    return (
        <div ref={citationRef}>
            <Button variant="link" onClick={thisClick}>
                {citationNumber}^
            </Button>
            <Excerpt
                excerptId={excerptId}
                onTextClicked={onTextClicked}
                hasEditPermission={true}
                selected={selected}
            />
        </div>
    )
};

export default Citation;